import { StateCreator } from 'zustand';
import { Middleware } from './common';

export interface FocusSlice {
  focusedPanelGroupId: number | undefined;
  setFocusedPanelGroupId: (id: number | undefined) => void;
  isFocusEnabled: boolean;
}

export function createFocusSlice(enabled = false): StateCreator<FocusSlice, Middleware, [], FocusSlice> {
  return (set) => ({
    focusedPanelGroupId: undefined,
    setFocusedPanelGroupId: (id: number | undefined) => {
      if (enabled) {
        set({ focusedPanelGroupId: id }, false, '[Focus] setFocusedPanelGroupId');
      }
    },
    isFocusEnabled: enabled,
  });
}
